import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import InstallPrompt from "@/components/InstallPrompt";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Scanner from "@/pages/Scanner";
import PhishingChecker from "@/pages/PhishingChecker";
import Alerts from "@/pages/Alerts";
import Protection from "@/pages/Protection";
import Pricing from "@/pages/Pricing";
import Billing from "@/pages/Billing";
import Admin from "@/pages/Admin";
import Install from "@/pages/Install";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="animate-spin text-primary" size={32} strokeWidth={1.5} />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (user) return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <InstallPrompt />
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: {
                background: "#0A0A0A",
                border: "1px solid #1A2E1E",
                borderRadius: 0,
                color: "#F4F4F5",
                fontFamily: "JetBrains Mono, monospace",
              },
            }}
          />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/install" element={<Install />} />
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
            <Route path="/app" element={<Protected><Layout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="scanner" element={<Scanner />} />
              <Route path="phishing" element={<PhishingChecker />} />
              <Route path="alerts" element={<Alerts />} />
              <Route path="protection" element={<Protection />} />
              <Route path="pricing" element={<Pricing />} />
              <Route path="billing" element={<Billing />} />
              <Route path="admin" element={<Admin />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
